import React from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAbortController } from "./useAbortController";
import { commonToast } from "../Utils";
import {
  handleTermsPopup,
  setDashboardStatus,
} from "../store/reducers/dashboardSlice";
import {
  setLenderID,
  setSelectedAccount,
} from "../store/reducers/accountSlice";

const useAccountSelect = () => {
  const { resetController } = useAbortController();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAccountSubmit = (e) => {
    if (e?.value) {
      if (location.pathname.includes("/loan-details")) {
        dispatch(handleTermsPopup(true));
        navigate("/");
      }
      resetController();
      dispatch(setSelectedAccount(e));
      dispatch(setLenderID(e?.value));
      dispatch(setDashboardStatus("idle"));
      toast.success("Account Changed", {
        ...commonToast,
      });
      // navigate("/loan-details-borrower");
      window.open("/loan-details-borrower", "_blank");
    }
  };

  return { handleAccountSubmit };
};

export default useAccountSelect;
